const blogs = [
  {
    id: 1,
    date: "2024-12-20",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas para Maximizar seus Ganhos no ABC Bet",
    descr:
      "Aprenda estratégias eficazes para melhorar sua experiência de jogos e apostas na plataforma ABC Bet.",
    fullText: `Maximizar seus ganhos em plataformas como a ABC Bet exige uma combinação de estratégia, paciência e conhecimento.\n
Entenda as regras de cada jogo antes de começar a apostar. Isso ajudará a evitar erros básicos e aumentará suas chances de ganhar.\n
Gerencie seu saldo com sabedoria. Nunca aposte mais do que está disposto a perder e estabeleça limites diários ou semanais.\n
Aproveite os bônus do Papai Noel e outras promoções sazonais oferecidas pela ABC Bet para aumentar seu saldo sem custo adicional.\n
Experimente diferentes jogos disponíveis na plataforma para encontrar os que melhor se adequam ao seu estilo de jogo.\n
Participe de torneios e competições para ter a chance de ganhar prêmios maiores e acumular mais pontos.\n
Use os modos de demonstração para praticar antes de apostar dinheiro real. Isso ajudará a entender melhor a mecânica dos jogos.\n
Leia as análises e dicas no blog ABC Bet para aprender com outros jogadores e especialistas da comunidade.\n
Aposte de forma responsável e divirta-se, lembrando que o principal objetivo é o entretenimento.`,
  },
  {
    id: 2,
    date: "2024-12-15",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Por que o ABC Bet é Confiável?",
    descr:
      "Descubra as razões que fazem da ABC Bet uma das plataformas mais seguras e confiáveis do mercado.",
    fullText: `A ABC Bet tem conquistado a confiança de seus usuários ao longo dos anos graças a sua dedicação à segurança e transparência.\n
Uma das principais razões é o uso de tecnologia de criptografia avançada para proteger os dados pessoais e financeiros dos jogadores.\n
A plataforma é licenciada por autoridades reguladoras reconhecidas, garantindo que opera de acordo com os padrões internacionais.\n
Os métodos de pagamento oferecidos incluem opções confiáveis e amplamente utilizadas, como cartões de crédito e carteiras digitais seguras.\n
Os jogos disponíveis no ABC Bet são auditados regularmente para garantir resultados justos e aleatórios.\n
Além disso, o suporte ao cliente está disponível 24/7 para resolver dúvidas e problemas de forma eficiente e amigável.\n
A política de jogo responsável incentiva os jogadores a estabelecerem limites e utilizarem ferramentas de autoexclusão se necessário.\n
Os feedbacks positivos de milhares de jogadores reforçam a reputação da plataforma como um ambiente confiável e divertido para apostas.`,
  },
  {
    id: 3,
    date: "2024-12-10",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Os Melhores Jogos de Slot no ABC Bet",
    descr:
      "Confira os slots mais populares e emocionantes disponíveis no ABC Bet e maximize sua diversão.",
    fullText: `Os jogos de slot são uma das principais atrações no ABC Bet, com opções para todos os gostos e estilos.\n
Entre os mais populares está o Fortune Tiger, que combina gráficos impressionantes com chances altas de ganhar grandes prêmios.\n
Outro destaque é o Galaxy Quest, um slot intergaláctico que oferece rodadas bônus e multiplicadores generosos.\n
O Mystic Treasures é ideal para quem gosta de aventuras e busca desbloquear tesouros escondidos.\n
Além disso, o ABC Bet oferece slots temáticos sazonais, como o Christmas Spins, perfeito para entrar no clima festivo.\n
A plataforma também disponibiliza modos de demonstração para que os jogadores possam testar os jogos antes de apostar.\n
Os slots são projetados por desenvolvedores renomados, garantindo qualidade e experiências imersivas.\n
Independentemente do jogo escolhido, a diversão é garantida com gráficos de última geração e animações vibrantes.`,
  },
  {
    id: 4,
    date: "2024-12-05",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Como Aproveitar ao Máximo os Bônus do ABC Bet",
    descr:
      "Saiba como utilizar os bônus oferecidos pela ABC Bet para maximizar suas chances de ganhar.",
    fullText: `Os bônus do ABC Bet são uma ótima maneira de aumentar suas chances de ganhar sem arriscar muito do seu próprio dinheiro.\n
O primeiro passo é sempre ler os termos e condições associados a cada bônus para entender os requisitos.\n
Aproveite o bônus de boas-vindas, que oferece um incentivo generoso para novos jogadores ao fazerem seu primeiro depósito.\n
Os bônus de recarga também são muito úteis para jogadores recorrentes, adicionando valor extra aos seus depósitos.\n
Outro destaque é o cashback semanal, que permite recuperar parte das perdas, tornando o jogo menos arriscado.\n
Participar de promoções sazonais, como as do Papai Noel, é uma maneira divertida de ganhar prêmios extras.\n
Use os bônus estrategicamente, concentrando-se em jogos que oferecem altas chances de vitória ou grandes jackpots.\n
Por fim, acompanhe o blog da ABC Bet para se manter atualizado sobre as últimas promoções e oportunidades.`,
  },
  {
    id: 5,
    date: "2024-12-01",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Estratégias para Jogos de Mesa no ABC Bet",
    descr:
      "Melhore seu desempenho em jogos de mesa como blackjack, roleta e pôquer com nossas dicas estratégicas.",
    fullText: `Os jogos de mesa no ABC Bet oferecem uma combinação única de habilidade e sorte, tornando-os emocionantes para todos os tipos de jogadores.\n
No blackjack, é essencial entender as probabilidades e quando parar ou pedir mais cartas para maximizar suas chances.\n
Na roleta, aposte de forma equilibrada entre números e cores para gerenciar riscos enquanto busca prêmios maiores.\n
O pôquer exige uma abordagem mais estratégica, como observar os padrões de aposta de seus oponentes e saber quando blefar.\n
Aproveite os modos ao vivo disponíveis na plataforma para uma experiência mais imersiva e autêntica.\n
Os limites de apostas variam, permitindo que jogadores de todos os níveis participem confortavelmente.\n
Além disso, as promoções específicas para jogos de mesa ajudam a aumentar o saldo e prolongar a diversão.\n
Leia livros ou tutoriais sobre as melhores práticas em jogos de mesa para aprofundar seu conhecimento.\n
A prática constante é a chave para melhorar suas habilidades e aproveitar ao máximo cada partida.`,
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/VK3k4NLq");
    });
  }
});
